/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form');
      this.optionSelectors = this.querySelectorAll('.option-selector:not(.option-selector--custom)');
      this.nativeSelector = document.getElementById(`variants-${this.section.dataset.section}`);
      this.data = this.getVariantData();
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();

      this.updateAvailability();
      this.resetUnavailableSelections();
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();
      this.updateAddToCartButton();

      // 🔹 Run cushion filter once on page load
      this.applyCushionFilter();

      this.addEventListener('change', this.handleVariantChange.bind(this));

      const priceCurrent = document.querySelector('.price__default .price__current');

      const observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            if(document.querySelector('.bold_option.bold_option_dropdown')){
            document.querySelector('.bold_option.bold_option_dropdown').addEventListener('change', this.handleVariantChange.bind(this));
            }
            // console.log('test');
          }
        }
      });

      // Options for the observer (which mutations to observe)
      const config = { childList: true, characterData: true, subtree: true };

      // Start observing the target element
      observer.observe(priceCurrent, config);


      this.setAttribute('loaded', '');
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();

      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;

      this.updateUrl(evt);
      this.updateVariantInput();
      this.updateAddToCartButton();
      this.updateAvailability();
      this.resetUnavailableSelections(evt);
      this.updatePrice();
      this.updateInventoryNotice();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateBarcode();
      VariantPicker.updateLabelText(evt);

      this.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: this.productForm,
          variant: this.variant,
          allVariants: this.data.variants,
          selectedOptions: this.selectedOptions
        }
      }));
      setTimeout(() => {
        if (typeof BOLD !== 'undefined'
          && typeof BOLD.common !== 'undefined'
          && BOLD.common.eventEmitter !== 'undefined') {
          BOLD.common.eventEmitter.emit('BOLD_COMMON_variant_changed', { variant: this.variant });
        }
      }, 1500);

      // Update Shipping text (custom liquid block)
      const shippingMessage = document.querySelectorAll('.ctmMsg');
      shippingMessage.forEach((message) => {
      if (this.variant && message.classList.contains(`ct-${this.variant.id}`)) {
        message.style.display = 'inline-block';
      } else {
        message.style.display = 'none';
      }
    });
        
    this.applyCushionFilter();
    }


    /**
     * 🔹 Custom: Applies cushion option filtering for grayn-join-bed
     */
    applyCushionFilter() {
      if (this.section?.dataset.productHandle !== "grayn-join-bed") return;

      // 🔹 Find selected size by looking for option-selector with label "Size"
      let sizeRaw = "";
      const allOptionSelectors = this.section.querySelectorAll(".option-selector");

      allOptionSelectors.forEach(sel => {
        const label = sel.querySelector("label");
        if (label && label.textContent.trim().toLowerCase() === "size") {
          const btn = sel.querySelector(".custom-select__btn span");
          if (btn) {
            sizeRaw = btn.textContent.trim();
          }
        }
      });

      const size = sizeRaw.toLowerCase();

      // 🔹 Find cushion selector by label text
      let cushionSelector = null;
      allOptionSelectors.forEach(sel => {
        const label = sel.querySelector("label");
        if (label && label.textContent.trim().toLowerCase() === "cushion") {
          cushionSelector = sel;
        }
      });

      if (!cushionSelector) {
        console.warn("❌ Cushion selector block NOT found (check label text).");
        return;
      }

      const options = cushionSelector.querySelectorAll(".custom-select__option");

      options.forEach(opt => {
        const val = opt.dataset.value.toLowerCase();

        if (val === "no cushion") {
          opt.style.display = "flex"; // always visible
        } else if (size === "queen" && val.includes("queen")) {
          opt.style.display = "flex";
        } else if (size === "king" && val.includes("king")) {
          opt.style.display = "flex";
        } else {
          opt.style.display = "none";
        }
      });

      // 🔹 Reset dropdown if invalid
      const btn = cushionSelector.querySelector(".custom-select__btn span");
      const current = btn ? btn.textContent.trim().toLowerCase() : "";

      if (!btn) {
        console.warn("❌ Cushion dropdown button not found, cannot reset.");
      } else if (
        (size === "queen" && current.includes("king")) ||
        (size === "king" && current.includes("queen"))
      ) {
        console.log("⚠️ Invalid cushion selected. Resetting to No Cushion.");
        btn.textContent = "No Cushion";

        options.forEach(opt => {
          const isReset = opt.dataset.value.toLowerCase() === "no cushion";
          opt.setAttribute("aria-selected", isReset);
        });
      } else {
        console.log("✅ Cushion selection is valid for current size, no reset needed.");
      }
    }


    updateAddToCartButton() {
      if (!this.productForm) return;
      if (this.selectedOptions.indexOf(null) > -1) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;
      const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;

      this.addBtn.disabled = !variantAvailable;
      this.addBtn.textContent = variantAvailable
        ? this.addBtn.dataset.addToCartText
        : unavailableStr;
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      el.classList.toggle('is-unavailable', !available);
      el.classList.toggle('is-nonexistent', !exists);

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            // el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
            el.innerHTML = `${el.innerHTML}`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
      } else {
        el.nextElementSibling.removeAttribute('title');
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      const { availabilityMode } = this.dataset; // 'down' or 'selection'
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.selectedOptions };
      }

      if (availabilityMode === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === this.selectedOptions[i] || this.selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
          });
        });
      }
    }

    /**
     * Resets any unavailable selections to the first available option.
     * This handles cascade resets when a parent option changes.
     * @param {object} evt - Event object.
     */
    resetUnavailableSelections(evt) {
      // Get the selector that triggered the change
      const changedSelector = evt?.target?.closest('.option-selector');
      let changedIndex = -1;

      // Find the index of the changed selector
      if (changedSelector) {
        this.optionSelectors.forEach((selector, index) => {
          if (selector === changedSelector) {
            changedIndex = index;
          }
        });
      }

      // Only reset options AFTER the one that was changed
      this.optionSelectors.forEach((selector, selectorIndex) => {
        // Skip if this is the changed selector or before it
        if (selectorIndex <= changedIndex) return;

        if (selector.dataset.selectorType === 'dropdown') {
          const customSelect = selector.querySelector('custom-select');
          if (!customSelect) return;

          const listbox = customSelect.querySelector('.custom-select__listbox');
          const activeId = listbox && listbox.getAttribute('aria-activedescendant');
          const selectedOption = (activeId && document.getElementById(activeId))
            || customSelect.querySelector('.custom-select__option[aria-selected="true"]');
          if (!selectedOption) return;

          // Check if current selection is unavailable AND nonexistent
          if (selectedOption.classList.contains('is-unavailable') &&
              selectedOption.classList.contains('is-nonexistent')) {

            // Find first available option (not unavailable+nonexistent, not empty value)
            const firstAvailable = customSelect.querySelector(
              '.custom-select__option:not(.is-unavailable.is-nonexistent):not([data-value=""])'
            );

            if (firstAvailable && firstAvailable !== selectedOption) {
              console.log('Cascade reset: Selecting', firstAvailable.dataset.value);

              // Update aria-selected
              selectedOption.setAttribute('aria-selected', 'false');
              firstAvailable.setAttribute('aria-selected', 'true');

              // Update button text
              const button = customSelect.querySelector('.custom-select__btn span');
              if (button) {
                // const label = firstAvailable.querySelector('.pointer-events-none');
                // button.textContent = label ? label.textContent.trim() : firstAvailable.textContent.trim();
                button.textContent = firstAvailable.textContent.trim();
              }

              // Update swatch if applicable
              if (firstAvailable.dataset.swatch) {
                const btn = customSelect.querySelector('.custom-select__btn');
                if (btn) btn.dataset.swatch = firstAvailable.dataset.swatch;
              }

              // Update listbox aria-activedescendant
              const listbox = customSelect.querySelector('.custom-select__listbox');
              if (listbox) {
                listbox.setAttribute('aria-activedescendant', firstAvailable.id);
              }

              // Dispatch change event to trigger variant update
              customSelect.dispatchEvent(new CustomEvent('change', {
                bubbles: true,
                detail: { selectedValue: firstAvailable.dataset.value }
              }));
            }
          }
        } else {
          // Handle radio/swatch selectors
          const selectedInput = selector.querySelector('input:checked');
          if (!selectedInput) return;

          const selectedLabel = selectedInput.nextElementSibling;
          if (!selectedLabel) return;

          // Check if current selection is unavailable AND nonexistent
          if (selectedInput.classList.contains('is-unavailable') &&
              selectedInput.classList.contains('is-nonexistent')) {

            // Find first available option
            const firstAvailable = selector.querySelector(
              'input.js-option:not(.is-unavailable.is-nonexistent)'
            );

            if (firstAvailable && firstAvailable !== selectedInput) {
              console.log('Cascade reset: Selecting radio', firstAvailable.value);
              firstAvailable.checked = true;
              firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      });
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default') ? '' : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the colour option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability = this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      this.price = this.price || this.section.querySelector('.product-price .price');
      if (!this.price) return;

      let { variant } = this;
      if (this.preSelection) {
        variant = this.data.variants[0];
        for (let i = 1; i < this.data.variants.length; i += 1) {
          if (this.data.variants[i].price < variant.price) variant = this.data.variants[i];
        }
      }

      if (variant) {
        const priceCurrentEl = this.price.querySelector('.price__current');
        const priceWasEl = this.price.querySelector('.price__was');
        const unitPriceEl = this.price.querySelector('.unit-price');

        // Update current price and original price if on sale.
        priceCurrentEl.innerHTML = this.data.formatted[variant.id].price;
        if (priceWasEl) priceWasEl.innerHTML = this.data.formatted[variant.id].compareAtPrice || '';

        // Update unit price, if specified.
        if (variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = variant.unit_price_measurement.reference_value;
          const unit = variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
          unitPriceEl.hidden = false;
        } else if (unitPriceEl) {
          unitPriceEl.hidden = true;
        }

        this.price.classList.toggle('price--on-sale', variant.compare_at_price > variant.price);
        this.price.classList.toggle('price--sold-out', !variant.available && !this.preSelection);
      }

      this.price.querySelector('.price__default').hidden = !this.variant && !this.preSelection;
      this.price.querySelector('.price__no-variant').hidden = this.variant || this.preSelection;
      const from = this.price.querySelector('.price__from');
      if (from) {
        from.hidden = !this.preSelection;
      }
    }

    /**
 * Updates the inventory notice based on the selected variant quantity.
 */
    updateInventoryNotice() {
      const inventoryNotice = this.section.querySelector('.product-inventory-notice');
      const thresholdEl = this.section.querySelector('.inventory_notice_threshold_value');
    
      if (!inventoryNotice || !thresholdEl) return;
    
      let { variant } = this;
      if (this.preSelection) {
        variant = this.data.variants[0];
      }
    
      // Ensure inventory is tracked
      if (!variant || variant.inventory_management !== 'shopify') {
        inventoryNotice.hidden = true;
        return;
      }
    
      if (typeof variant.inventory_quantity !== 'undefined') {
        const quantity = variant.inventory_quantity;
        const threshold = parseInt(thresholdEl.dataset.threshold_value, 10) || 0;
    
        if (quantity > 0 && quantity <= threshold) {
          inventoryNotice.classList.remove('product-inventory-notice--no-inventory');
          inventoryNotice.textContent = `${quantity} In Stock`;
        } else {
          inventoryNotice.classList.add('product-inventory-notice--no-inventory');
          inventoryNotice.textContent = ''; // Hide text when above threshold
        }
    
        inventoryNotice.hidden = false;
      } else {
        inventoryNotice.hidden = true;
      }
    }
    
    

    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;

      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcode = this.barcode || this.section.querySelector('.product-barcode__value');
      if (!this.barcode) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
      this.barcode.parentNode.hidden = !barcodeAvailable;
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false') return;
      const url = this.variant ? `${this.dataset.url}?variant=${this.variant.id}` : this.dataset.url;
      window.history.replaceState({ }, '', url);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms = this.forms || this.section.querySelectorAll('.js-product-form, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('[name="id"]');
        input.value = this.variant ? this.variant.id : '';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /**
     * Gets the variant data for a product.
     * @returns {?object}
     */
    getVariantData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get the selected values from a list of variant options.
     * @returns {Array} Array of selected option values, value is null if not selected.
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const listbox = selector.querySelector('.custom-select__listbox');
          const activeId = listbox && listbox.getAttribute('aria-activedescendant');
          const selected = (activeId && document.getElementById(activeId))
            || selector.querySelector('.custom-select__option[aria-selected="true"]');
          selectedOptions.push(selected && selected.dataset.value !== '' ? selected.dataset.value : null);
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      return this.data.variants.find(
        (v) => v.options.every((val, index) => val === this.selectedOptions[index])
      );
    }
  }

  customElements.define('variant-picker', VariantPicker);
}
